import { createRouter, createWebHistory } from 'vue-router';
import { useUsers } from '@/features/users/controller';

const routes = [
  {
    path: '/',
    name: 'home',
    component: () => import('@/views2/HomeView.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/commande/:id',
    name: 'order-detail',
    component: () => import('@/views2/OrderDetailView.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/categories',
    name: 'categories',
    component: () => import('@/views/HomeView.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/categorie/:id',
    name: 'category',
    component: () => import('@/views/CategoryView.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/produit/:id',
    name: 'product',
    component: () => import('@/views/ProductView.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/panier',
    name: 'cart',
    component: () => import('@/views/CartView.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/connexion',
    name: 'login',
    component: () => import('@/views2/LoginView.vue'),
    meta: { requiresAuth: false }
  },
  {
    path: '/mot-de-passe-oublie',
    name: 'forgot-password',
    component: () => import('@/views2/ForgotPasswordView.vue'),
    meta: { requiresAuth: false }
  },
  {
    path: '/reinitialiser-mot-de-passe',
    name: 'reset-password',
    component: () => import('@/views2/ResetPasswordView.vue'),
    meta: { requiresAuth: false }
  },
  {
    path: '/activate-account',
    name: 'activate-account',
    component: () => import('@/views2/ActivateAccountView.vue'),
    meta: { requiresAuth: false }
  },
  {
    path: '/:pathMatch(.*)*',
    redirect: "/connexion",
  }
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.beforeEach(async (to, from, next) => {
  const $userStore = useUsers();

  if (to.meta.requiresAuth && !$userStore.loggedUser) {
    await $userStore.getUserAdmin();
    if (!$userStore.loggedUser) return next('/connexion');
  }

  next();
});

export default router;